import api from "@/router/api"

export default {
    listTypologies({commit}, payload){
        return new Promise((resolve, reject) => {
            api.auxiliariesTypologies.list(payload)
                .then(response => {
                    resolve(response.data.data)

                    commit('SET_TYPOLOGIES', response.data.data)
                })
                .catch(error => {
                    reject({
                        message: 'Ocurrió un problema al obtener las tipologias',
                    })
                })
        })
    },
    getAllTypologies({commit}, payload){
        return new Promise((resolve, reject) => {
            api.auxiliariesTypologies.listAll(payload)
            .then(response => {
                resolve(response.data.data)

                commit('SET_TYPOLOGIES', response.data.data.data)
            })
            .catch(error => {
                reject({
                    message: 'Ocurrió un problema al obtener las tipologias',
                })
            })
        })
    },
    findTypology({commit}, payload){
        return new Promise((resolve, reject) => {
            api.auxiliariesTypologies.find(payload)
                .then(response => {
                    resolve(response.data.data)

                    commit('SET_TYPOLOGY', response.data.data)
                })
                .catch(error => {
                    reject({
                        message: 'Ocurrió un problema al obtener la tipología',
                    })
                })
        })
    },
    createTypology({commit}, payload){
        commit('CLEAR_VALIDATION')
        return new Promise((resolve, reject) => {
            api.auxiliariesTypologies.create(payload)
                .then(response => {
                    const {data} = response.data
                    commit('SET_TYPOLOGIES', response.data.data)
                    resolve(data)
                })
                .catch(error => {
                    const { data, status} = error.response
                    const { message: title } = data

                    if(status === 422){
                        commit('SET_VALIDATION_ERRORS', data.errors)
                    }
                    reject({title, status})
                })
        })
    },
    updateTypology({commit}, payload){
        commit('CLEAR_VALIDATION')
        return new Promise((resolve, reject) => {
            api.auxiliariesTypologies.update(payload)
                .then(response => {
                    const {data} = response.data

                    resolve(data)
                })
                .catch(error => {
                    const { data, status} = error.response
                    const { message: title } = data

                    if(status === 422){
                        commit('SET_VALIDATION_ERRORS', data.errors)
                    }
                    reject({title, status})
                })
        })
    },
    deleteTypology({commit}, payload) {
        return new Promise((resolve, reject) => {
            api.auxiliariesTypologies.delete(payload)
                .then(response => {
                    const {data} = response.data

                    resolve(data)
                })
                .catch(() => {
                    reject({
                        message: 'Error al eliminar la tipología.',
                    })
                })
        })
    },
}
